import React, { useEffect, useRef, useState } from "react";
import { Nav, Navbar, Dropdown } from "react-bootstrap";
import TelegramIcon from "../assets/images/telegramIcon.svg";
import HomeIcon from "../assets/images/games-icon/home-icon.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../redux/auth/actions";
import MobLeftbar from "./MobLeftbar";
import GamesSearchModal from "../views/components/GamesSearchModal";
import { useOutsideAlerter } from "../hooks/useOutsideClick";
import { getNotifications } from "../redux/app/actions";

const HEADER_ULS = [
  "sports",
  "/sportsbook/Cricket",
  "/sportsbook/Tennis",
  "/sportsbook/Soccer",
  "/sportsbook/Horse Racing",
  "/Casino",
  "/slots",
  "/live-dealer",
  "/casino/ezg-one-day-teen-patti",
  "/casino/ezgevo-lobby-poker",
  "/casino/ezg-andar-bahar",
  "/casino/ezg-lucky-7",
  "/casino/qtech",
];

const HeaderAfterLogin = () => {
  const location = useLocation();
  const { user, wallet } = useSelector((state) => state.auth);
  const [show1, setShow1] = useState(false);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activePage, setActivePage] = useState("");
  const { appDetails } = useSelector((state) => state.app);
  const catMenu = useRef(null);

  useOutsideAlerter(catMenu, setShow1);

  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  useEffect(() => {
    const isClassAddedLocalStorage = localStorage.getItem("isClassAdded");
    if (isClassAddedLocalStorage) {
      document.body.classList.add("light-theme");
    }
  }, []);

  const htmlElement = document.documentElement;

  useEffect(() => {
    if (show1) {
      htmlElement.style.overflow = "hidden";
      document.body.classList.add("leftbat-opened");
    } else {
      htmlElement.style.overflow = "auto";
      document.body.classList.remove("leftbat-opened");
    }
  }, [show1]);

  useEffect(() => {
    const matchedValue = HEADER_ULS.find((f) => {
      const splitPath = window.location.pathname.split("/")?.[1];
      if (
        splitPath === f &&
        !f.includes("spmsports") &&
        !f.includes("casino")
      ) {
        return true;
      } else if (
        (f.includes("spmsports") || f.includes("casino")) &&
        f === window.location.pathname
      ) {
        return true;
      } else if (f === window?.location?.pathname) {
        return true;
      }
    });
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  return (
    <>
      <header className="header afterlogin">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <a href="/" className="me-2 d-block d-md-none">
                    <img
                      src={HomeIcon}
                      alt="User Menu Icon"
                      width={25}
                      id="menuSidebarHandlerImg"
                    />
                  </a>

                  <div className="logo">
                    <a href="/sports">
                      <img src={appDetails?.LOGO_URL} alt="Logo" />
                      {/* <img src={logo} alt="Logo" /> */}
                    </a>
                  </div>
                </div>

                <div className="headerRightsection">
                  <div className="headerRight">
                    <ul>
                      <li className="d-md-block d-none">
                        <GamesSearchModal />
                      </li>

                      <li className="d-md-block d-none">
                        <a
                          href=""
                          onClick={() => navigate("/termsandcondition")}
                        >
                          Rules
                        </a>
                      </li>

                      <li className="balance">
                        <div className="balance-amount">
                          {/* <div className="withdraw">
                          <a href="" onClick={() => navigate("/withdraw")}>
                            W
                          </a>
                        </div> */}

                          <div className="d-sm-flex flex-column BalanceSection px-1 px-md-2">
                            <div className="cash px-1">
                              <span>Cash:</span> <span>{wallet?.cash}</span>
                            </div>
                            <div className="bonus px-1">
                              <span>Bonus:</span> <span>{wallet?.coins}</span>
                            </div>
                            <div className="balance align-items-center px-1">
                              <span>Balance:&nbsp;</span>
                              <span>{wallet?.balance}</span>
                            </div>
                          </div>

                          {/* <div className="deposit">
                          <a
                            href="javascript:void(0)"
                            onClick={() => navigate("/gatewaylist")}
                          >
                            D
                          </a>
                        </div> */}
                        </div>
                      </li>
                      <li className="head-social">
                        <a
                          href={
                            appDetails?.TELEGRAM != ""
                              ? appDetails?.TELEGRAM
                              : "#"
                          }
                          target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                        >
                          <img src={TelegramIcon} alt="telegram" />
                        </a>
                      </li>
                    </ul>

                    <Dropdown className="ProfileDropdown">
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <p>{user?.mstruserid}</p>
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item href="/profile">Profile</Dropdown.Item>
                        {/* <Dropdown.Item href="/gatewaylist">Deposit</Dropdown.Item>
                        <Dropdown.Item href="/withdraw">Withdraw</Dropdown.Item> */}
                        <Dropdown.Item href="/mybets">My Bets</Dropdown.Item>
                        {/* <Dropdown.Item href="/bonus">Bonus</Dropdown.Item>
                        <Dropdown.Item href="/referral">Referral</Dropdown.Item> */}
                        <Dropdown.Item href="/cashier">
                          Account Statement
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="javascript:void(0)"
                          onClick={() => dispatch(logoutUser())}
                        >
                          Sign Out
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  {(websiteNotifications.length && showNotifications && (
                    <div className="marqu d-md-block d-none">
                      <marquee>
                        {websiteNotifications.map((notf, idx) => (
                          <label style={{ marginRight: "30px" }} key={idx}>
                            {notf?.content}
                          </label>
                        ))}
                      </marquee>
                    </div>
                  )) ||
                    null}
                </div>
              </div>

              <div className="d-md-none d-flex align-items-center mb-1">
                <GamesSearchModal />
                {(websiteNotifications.length && showNotifications && (
                  <div className="marqu ">
                    <marquee>
                      {websiteNotifications.map((notf, idx) => (
                        <label style={{ marginRight: "30px" }} key={idx}>
                          {notf?.content}
                        </label>
                      ))}
                    </marquee>
                  </div>
                )) ||
                  null}
              </div>
            </div>
          </div>
        </div>

        <div className="bottom-head MobSectionNav d-md-none d-flex">
          <Navbar.Collapse id="basic-navbar-nav" className="d-block">
            <Nav className="me-auto">
              <div
                onClick={() => {
                  navigate("/casino/qtech");
                }}
                className={
                  activePage === "/casino/qtech"
                    ? "active nav-link"
                    : "nav-link"
                }
              >
                <span>Qtech</span>
              </div>
              <div
                onClick={() => {
                  navigate("/sportsbook/Cricket");
                }}
                className={
                  activePage === "/sportsbook/Cricket"
                    ? "active nav-link"
                    : "nav-link"
                }
              >
                <span>SPORTS</span>
              </div>

              <div
                onClick={() => {
                  navigate("/live-dealer");
                }}
                className={
                  activePage === "/live-dealer" ? "active" : "nav-link"
                }
              >
                <span> CASINO</span>
              </div>

              <Dropdown className="CasinoDropdown d-md-none d-block">
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <span>Our Casino</span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <div className="DropDown">
                    <Dropdown.Item href="/casino/ezugi">Ezugi</Dropdown.Item>

                    <Dropdown.Item href="/casino/evolution">
                      Evolution
                    </Dropdown.Item>
                    <Dropdown.Item href="/casino/vivo">Vivo</Dropdown.Item>
                    <Dropdown.Item href="/casino/supernowa">
                      Supernowa
                    </Dropdown.Item>
                    <Dropdown.Item href="/casino/xpg">XPG</Dropdown.Item>
                    <Dropdown.Item href="/casino/qtech">Qtech</Dropdown.Item>
                    <Dropdown.Item href="/Casino">Live Casino</Dropdown.Item>
                    <Dropdown.Item href="/Slots">Slots</Dropdown.Item>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
        </div>

        <div className="bottom-head">
          <Navbar.Collapse id="basic-navbar-nav" className="d-block">
            <Nav className="me-auto">
              <div
                onClick={() => {
                  navigate("/");
                }}
                className={
                  activePage === "sports" ? "active nav-link" : "nav-link"
                }
              >
                <span>Home</span>
              </div>
              <div
                onClick={() => {
                  navigate("/sportsbook/Cricket");
                }}
                className={
                  activePage === "/sportsbook/Cricket"
                    ? "active nav-link"
                    : "nav-link"
                }
              >
                <span>Cricket</span>
              </div>
              <div
                onClick={() => {
                  navigate("/sportsbook/Tennis");
                }}
                className={
                  activePage === "/sportsbook/Tennis"
                    ? "active nav-link  "
                    : "nav-link"
                }
              >
                <span>Tennis</span>
              </div>
              <div
                onClick={() => {
                  navigate("/sportsbook/Soccer");
                }}
                className={
                  activePage === "/sportsbook/Soccer"
                    ? "active nav-link  "
                    : "nav-link"
                }
              >
                <span>Football</span>
              </div>
              <div
                onClick={() => {
                  navigate("/sportsbook/Horse Racing");
                }}
                className={
                  activePage === "/sportsbook/Horse Racing"
                    ? "active nav-link"
                    : "nav-link"
                }
              >
                <span>Horse Racing</span>
              </div>
              <div
                onClick={() => {
                  navigate("/casino/ezg-one-day-teen-patti");
                }}
                className={
                  activePage === "/casino/ezg-one-day-teen-patti"
                    ? "active nav-link"
                    : "nav-link"
                }
              >
                <span>One Day Teen Patti</span>
              </div>
              <div
                onClick={() => {
                  navigate("/casino/ezgevo-lobby-poker");
                }}
                className={
                  activePage === "/casino/ezgevo-lobby-poker"
                    ? "active nav-link"
                    : "nav-link"
                }
              >
                <span>Live Poker</span>
              </div>
              <div
                onClick={() => {
                  navigate("/casino/ezg-andar-bahar");
                }}
                className={
                  activePage === "/casino/ezg-andar-bahar"
                    ? "active nav-link"
                    : "nav-link"
                }
              >
                <span>Andar Bahar</span>
              </div>
              <div
                onClick={() => {
                  navigate("/casino/ezg-lucky-7");
                }}
                className={
                  activePage === "/casino/ezg-lucky-7"
                    ? "active nav-link  "
                    : "nav-link"
                }
              >
                <span>Lucky 7</span>
              </div>
              <div
                onClick={() => {
                  navigate("/sportsbook/Cricket");
                }}
                className={
                  activePage === "/casino/ezg-lucky-7"
                    ? "active nav-link  "
                    : "nav-link"
                }
              >
                <span>Exchange 1</span>
              </div>
              <div
                onClick={() => {
                  navigate("/sportsbook/Inplay");
                }}
                className={
                  activePage === "/casino/ezg-lucky-7"
                    ? "active nav-link  "
                    : "nav-link"
                }
              >
                <span>Exchange 2</span>
              </div>
              <Dropdown className="CasinoDropdown d-md-block d-none">
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <span>Our Casino</span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <div className="DropDown">
                    <Dropdown.Item href="/casino/ezugi">Ezugi</Dropdown.Item>

                    <Dropdown.Item href="/casino/evolution">
                      Evolution
                    </Dropdown.Item>
                    <Dropdown.Item href="/casino/vivo">Vivo</Dropdown.Item>
                    <Dropdown.Item href="/casino/supernowa">
                      Supernowa
                    </Dropdown.Item>
                    <Dropdown.Item href="/casino/xpg">XPG</Dropdown.Item>
                    <Dropdown.Item href="/casino/qtech">Qtech</Dropdown.Item>
                    <Dropdown.Item href="/Casino">Live Casino</Dropdown.Item>
                    <Dropdown.Item href="/Slots">Slots</Dropdown.Item>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
        </div>

        {show1 && <MobLeftbar className="d-block d-md-none" ref={catMenu} />}
      </header>
    </>
  );
};

export default HeaderAfterLogin;
